<div class="transition-container">
  <div class="transition-content">
    <div class="logo-section">
      <div class="logo-wrapper">
        @if (logoImage) {
          <img [src]="logoImage" [alt]="appName" class="app-logo animated-logo" />
        }
        @if (!logoImage) {
          <div class="fallback-logo animated-logo">
            {{ appName.charAt(0) }}
          </div>
        }
      </div>
    </div>

    <div class="message-section">
      <h2 class="launching-text">Launching {{ appName }}</h2>
      <p class="subtitle-text">Please wait while we set things up for you</p>
    </div>

    <div class="progress-section">
      <div class="progress-bar-container">
        <div class="progress-bar-fill"></div>
      </div>
    </div>

    <div class="retry-section" [class.show]="showRetry">
      <p class="retry-text">Launch taking longer than expected?</p>
      <button class="btn-retry" (click)="retry()">
        <span class="retry-icon">↺</span> Try Again
      </button>
    </div>
  </div>

  <div class="background-effects">
    <div class="glow-orb"></div>
  </div>
</div>